import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "announcement-center" }
const _hoisted_2 = { class: "header-section" }
const _hoisted_3 = { class: "header-actions" }
const _hoisted_4 = { class: "announcements-list" }
const _hoisted_5 = { class: "announcement-header" }
const _hoisted_6 = { class: "announcement-title" }
const _hoisted_7 = { class: "time" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "announcement-meta" }
const _hoisted_10 = { class: "status" }
const _hoisted_11 = {
  key: 0,
  class: "loading"
}
const _hoisted_12 = {
  key: 1,
  class: "empty-state"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_page_header, {
      onBack: _ctx.goBack,
      content: "系统公告"
    }, null, 8, ["onBack"]),
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("h2", null, "系统公告", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          disabled: _ctx.unreadCount === 0,
          onClick: _ctx.markAllAsRead,
          type: "primary",
          round: ""
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode(" 全部标记为已读 ", -1)
          ]))]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.announcements, (item) => {
        return (_openBlock(), _createBlock(_component_el_card, {
          key: item.id,
          class: _normalizeClass(["announcement-item", { unread: item.isRead === 0 }])
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_el_badge, {
                  "is-dot": item.isRead === 0,
                  class: "announcement-badge"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("h3", null, _toDisplayString(item.title), 1)
                  ]),
                  _: 2
                }, 1032, ["is-dot"])
              ]),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.formatDate(item.createTime || item.publishTime)), 1)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["announcement-content", { expanded: item.expanded }]),
              innerHTML: item.content
            }, null, 10, _hoisted_8),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_el_tag, {
                type: "info",
                size: "small"
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("系统公告", -1)
                ]))]),
                _: 1
              }),
              _createElementVNode("span", _hoisted_10, _toDisplayString(item.isRead ? '已读' : '未读'), 1),
              _createVNode(_component_el_button, {
                type: "primary",
                link: "",
                class: "expand-btn",
                onClick: ($event: any) => (_ctx.toggleExpand(item))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.expanded ? '收起' : '展开'), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          _: 2
        }, 1032, ["class"]))
      }), 128)),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
              return _createElementVNode("div", {
                key: 'skeleton'+n,
                class: "skeleton-item"
              }, [
                _createVNode(_component_el_skeleton, {
                  rows: 3,
                  animated: ""
                })
              ])
            }), 64))
          ]))
        : _createCommentVNode("", true),
      (_ctx.announcements.length === 0 && !_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_el_empty, { description: "暂无系统公告" })
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.total > 0)
      ? (_openBlock(), _createBlock(_component_el_pagination, {
          key: 0,
          class: "pagination",
          onSizeChange: _ctx.handleSizeChange,
          onCurrentChange: _ctx.handleCurrentChange,
          "current-page": _ctx.currentPage,
          "page-sizes": [10, 20, 30, 50],
          "page-size": _ctx.pageSize,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _ctx.total
        }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"]))
      : _createCommentVNode("", true)
  ]))
}